import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import stockRequestEn from 'locales/en/stockRequest.json';
import stockRequestPl from 'locales/pl/stockRequest.json';
import stockRequestRo from 'locales/ro/stockRequest.json';

i18n.use(initReactI18next).init({
  resources: {
    en: { stockRequest: stockRequestEn },
    pl: { stockRequest: stockRequestPl },
    ro: { stockRequest: stockRequestRo }
  },
  lng: 'en',
  fallbackLng: 'en',
  ns: ['stockRequest'],
  defaultNS: 'stockRequest',
  interpolation: { escapeValue: false }
});

export default i18n;
